module.exports = __webpack_public_path__ + "static/media/fvs_valve1_1.4bb00cb5.jpg";